import { FC, ReactNode } from "react";
import { Box, Grid, Container, Typography, Button } from "@mui/material";
import WorkTwoToned from "@mui/icons-material/WorkTwoTone";
import NextWeekTwoToned from "@mui/icons-material/NextWeekTwoTone";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { useNavigate } from "react-router";
import { useAuthContext } from "../../providers/AuthProvider";
interface Exp {
  label: string;
  value: string;
  icon: ReactNode;
}
interface ExpItemProps {
  item: Exp;
}

const exps: Array<Exp> = [
  {
    label: "Verified Campaigns",
    value: "50+",
    icon: <WorkTwoToned fontSize="large" color="primary" />,
  },
  {
    label: "Auto & Cab Branding Focused",
    value: "",
    icon: <BusinessOutlinedIcon fontSize="large" color="primary" />,
  },
  {
    label: "Trusted Advertising Companies",
    value: "20+",
    icon: <PeopleAltOutlinedIcon fontSize="large" color="primary" />,
  },
  {
    label: "On-Ground Gigs Across India",
    value: "21+",
    icon: <NextWeekTwoToned fontSize="large" color="primary" />,
  },
];

const ExpItem: FC<ExpItemProps> = ({ item }) => {
  const { value, label, icon } = item;

  return (
    <Box
    sx={{
      backgroundColor: "background.default",
      mb: { xs: 1, md: 0 },
      borderRadius: 2,
      width: "100%",
      height: "120px"  // Fixed height for all boxes
    }}
  >
    <Grid 
      container 
      sx={{ 
        padding: 2,
        height: "100%",
        alignItems: "center"
      }}
    >
      {/* Left side - Icon */}
      <Grid item xs={3} sx={{ display: "flex", justifyContent: "center" }}>
        <Box
          sx={{
            width: "72px",
            height: "72px",
            backgroundColor: "#E7F0FA",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 1,
          }}
        >
          {icon}
        </Box>
      </Grid>
      
      <Grid item xs={9} sx={{pl:1}} >
        <Box>
          <Typography
            margin={0}
            sx={{ fontSize: { xs: 22, md: 24 }, fontWeight: "bold" }}
          >
            {value}
          </Typography>
          <Typography
            color="text.secondary"
            sx={{
              fontSize: { xs: 14, md: 16 },
              fontFamily: "inter, sans-serif",
            }}
          >
            {label}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  </Box>
  );
};

const HomeHero: FC = () => {
  const history = useNavigate();
  const { isAuthenticated, loginWithRedirect } = useAuthContext();
  const redirectToAppliedJobs = () => {
    history("/task/gigHistory");
  };
  return (
    <Box
      className="hero-home"
      id="hero"
      sx={{
        backgroundColor: "background.paper",
        position: "relative",
        pt: 4,
        pb: { xs: 8, md: 10 },
      }}
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={0}
          sx={{ flexDirection: { xs: "column", md: "unset" } }}
        >
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                textAlign: { xs: "center", md: "left" },
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Box sx={{ mb: 3 }}>
                <Typography
                  component="h2"
                  sx={{
                    position: "relative",
                    fontSize: { xs: 36, md: 56 },
                    letterSpacing: 1.5,
                    fontWeight: "bold",
                    fontFamily: "inter, sans-serif",
                    lineHeight: 1.1,
                  }}
                >
                  Get Paid to Verify Auto & Cab Ads in Your City
                </Typography>
              </Box>
              <Box sx={{ mb: 4, width: { xs: "100%", md: "80%" } }}>
                <Typography
                  sx={{
                    color: "text.secondary",
                    lineHeight: 1.6,
                    fontFamily: "inter, sans-serif",
                  }}
                >
                  {
                    "Welcome to gOGig – India’s first gig platform focused on transit media verification. We connect companies running auto rickshaw and cab branding campaigns with local gig workers who can verify on-ground execution. Whether you're a company looking to outsource verification tasks or a gig seeker wanting to earn daily, we’ve got you covered."
                  }
                </Typography>
                <Button
                  sx={{ marginTop: "15px" }}
                  size="small"
                  variant="contained"
                  onClick={
                    isAuthenticated
                      ? redirectToAppliedJobs
                      : () => loginWithRedirect({})
                  }
                >
                  {isAuthenticated ? "My applied gigs" : "Get started"}
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box
              sx={{ lineHeight: 0, display: "flex", justifyContent: "center" }}
            >
              <img
                style={{ maxWidth: "100%" }}
                src={`${process.env.PUBLIC_URL}/images/home/Illustration.png`}
                alt="Hero img"
              />
            </Box>
          </Grid>
        </Grid>

        <Grid container spacing={2} mt={4}>
          {exps.map((item, index) => (
            <Grid key={index} item xs={6} md={3}>
              <ExpItem item={item} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default HomeHero;
